export const ORDER_STATUS = {
  menunggu_pembayaran: { label: "Menunggu Pembayaran", cls: "bg-yellow-100 text-yellow-800" },
  diproses: { label: "Diproses", cls: "bg-blue-100 text-blue-700" },
  dikirim: { label: "Sudah Dikirim", cls: "bg-emerald-100 text-emerald-700" },
  selesai: { label: "Selesai", cls: "bg-emerald-100 text-emerald-700" },
  dibatalkan: { label: "Dibatalkan", cls: "bg-red-100 text-red-700" },
};

export const statusOf = (s) => ORDER_STATUS[s] || ORDER_STATUS.diproses;
